export default "__VITE_ASSET___6OWPw40__"